import React from "react";
import "./NomineeDetails.css";
import { useState, useEffect } from "react";
import axios from "axios";
import { url } from "../../../../../App";
import {ToastContainer } from "react-toastify";
import PDFViewer from "../../../../Borrower/BorrowerDetails/Components/PDFViewer/PDFViewer";
import Cookies from 'js-cookie';
import CattleModal from "../CattleModal/CattleModal"
import LifeModal from "../LifeModal/LifeModal"
import HealthModal from "../HealthModal/HealthModal"
import PropertyModal from "../PropertyModal/PropertyModal"

const NomineeDetails = ({loanData, permissions }) => {
  const token = Cookies.get('Token');
  const email = Cookies.get('Email');
  const [dairyLoan, setDairyLoan] = useState(false);
  const [lapLoan, setLapLoan] = useState(false);
  const [viewCattleModal, setviewCattleModal] = useState(false);
  const [viewLifeModal, setviewLifeModal] = useState(false);
  const [viewPropertyModal, setviewPropertyModal] = useState(false);
  const [viewHealthModal, setviewHealthModal] = useState(false);

  const openCattleModal = () => {
    setviewCattleModal(true);
  };
  const closeCattleModal = () => {
    setviewCattleModal(false);
  };

  const openLifeModal = () => {
    setviewLifeModal(true);
  };
  const closeLifeModal = () => {
    setviewLifeModal(false);
  };

  const openPropertyModal = () => {
    setviewPropertyModal(true);
  };
  const closePropertyModal = () => {
    setviewPropertyModal(false);
  };

  const openHealthModal = () => {
    setviewHealthModal(true);
  };
  const closeHealthModal = () => {
    setviewHealthModal(false);
  };

  const [pdfModal, setPdfModal] = useState({
    open: false,
    data: `data:application/pdf;base64,${url}`,
  });

  useEffect(() => {
    axios
    .post(url + "/loanproduct/getsingle", {
      token: token,
      email: email,
      loanproduct_id: loanData.loanproduct_id,
    })
    .then((res) => {
      // console.log(res.data)
      if (res.data[0].loanproduct_group === 'DAIRY LOAN') {
        setDairyLoan(true)
      }
      if(res.data[0].loanproduct_group === 'MICRO-LAP LOAN'){
        setLapLoan(true)
      }
    })
    .catch((err) => {
      console.log(err);
    });

  }, [token, email,loanData.loanproduct_id,loanData,loanData.loan_id]);
 
  const closePdfViewer = () => {
    setPdfModal((prevState) => ({
      ...prevState,
      open: false,
      data: "",
    }));
  };

  return (
    <>
      <ToastContainer />
      {pdfModal.open && (
        <PDFViewer url={pdfModal.data} closeModal={closePdfViewer} />
      )}

      {viewCattleModal && (
        <CattleModal loanId={loanData.loan_id} closeModal={closeCattleModal} />
      )}

      {viewLifeModal && (
        <LifeModal loanId={loanData.loan_id} closeModal={closeLifeModal} />
      )}

      {viewHealthModal && (
        <HealthModal loanId={loanData.loan_id} closeModal={closeHealthModal} />
      )}

      {viewPropertyModal && (
        <PropertyModal loanId={loanData.loan_id} closeModal={closePropertyModal} />
      )}
      
      <div className="nominee-details">
        <div className="life-insurance-form">
          <p style={{ color: "red", fontWeight: "bold" }}>*Note:Please Upload All Insurance in Pdf Format Only.</p><br />
          <div style={{ display: "flex", gap: "11.5rem" }}>
            <div>
              <h3>Life Insurance</h3>
            </div>
            <div className="insaurance-buttons">
              {permissions.view_loan_document && (
                <button onClick={openLifeModal}>
                  View
                </button>
              )}
            </div>
          </div>
        </div>
        <div className="health-insurance-form">
          <div style={{ display: "flex", gap: "10rem" }}>
            <div>
              <h3>Health Insurance</h3>
            </div>
            <div className="insaurance-buttons">
              {permissions.view_loan_document && (
                <button onClick={openHealthModal}>
                  View
                </button>
              )}
            </div>
          </div>
        </div>
        
        {lapLoan ? (
          <div className="property-insurance-form">
            <div style={{ display: "flex", gap: "8.7rem" }}>
              <div>
                <h3>Property Insurance</h3>
              </div>
              <div className="insaurance-buttons">
                {permissions.view_loan_document && (
                  <button onClick={openPropertyModal}>
                    View
                  </button>
                )}
              </div>
            </div>
          </div>
         ) : null}
        
        {dairyLoan ? (
          <div className="other-insurance-form">
            <div style={{ display: "flex", gap: "10.4rem" }}>
              <div>
                <h3>Cattle Insurance</h3>
              </div>
              <div className="insaurance-buttons">
                {permissions.view_loan_document && (
                  <button onClick={openCattleModal}>
                    View
                  </button>
                )}
              </div>
            </div>
          </div>
        ) : null}

      </div>
    </>
  );
};

export default NomineeDetails;
